import { FormGroup, Input, Label } from "reactstrap";
import { useThemeContext } from "../../Context/ThemeContext";
import { getDarkInput } from "../../Utils/otherFunctions";

const TimeInputField = ({
  state,
  label,
  name,
  defaultValue,
  value,
  onChange,
  className,
  disabled,
  size,
}) => {
  const { themeContext } = useThemeContext();

  const defaultIfEmpty = (value) => {
    return value === "" ? "" : value;
  };

  return (
    <FormGroup className={className}>
      {label && (
        <Label for={name} className={"bg-transparent"}>
          {label}
        </Label>
      )}
      <Input
        className={getDarkInput(themeContext)}
        type="time"
        id={name}
        name={name}
        onChange={onChange}
        // defaultValue={defaultValue}
        disabled={disabled}
        size={size}
        value={defaultValue || value || (state && defaultIfEmpty(state[name]))}
      />
    </FormGroup>
  );
};

export default TimeInputField;
